import script from "./MobileNumbersTableIntegration.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileNumbersTableIntegration.vue?vue&type=script&setup=true&lang=js"

import "./MobileNumbersTableIntegration.vue?vue&type=style&index=0&id=082d8142&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-082d8142"]])

export default __exports__